
<!--地球操作MainGlobeOperation混入方法：影像中心标记创作标记相关-->

<script>
export default {
  name: "MainGlobeOperationMarker",
    data(){
      return {
          //'''''''''''''数据列表的属性''''''''''''''''''''
          nodeName:"",
          currentNodeKey:'',
          markerHandleList:[],
          oldLength:0,
          currSize:"",
          currWidth:'',
          //是否有新数据
          isNewData:true,
          newDataTemp:'',
          noReadTemp:'',
          //'''''''''''''''图层列表的属性''''''''''''''''''''''
          currentLayerNodeKey:'',
          dataListShow:true,
          layerListShow:false,
      }
    },
    watch: {
        currentNodeKey(newVal) {
            if (newVal.toString()) {
                this.$refs.markerTree.setCurrentKey(newVal);
            } else {
                this.$refs.markerTree.setCurrentKey(null);
            }
        },
        currentLayerNodeKey(newVal) {
            if (newVal.toString()) {
                this.$refs.layerTree.setCurrentKey(newVal);
            } else {
                this.$refs.layerTree.setCurrentKey(null);
            }
        },
        // globeOperationMarkerList:{
        //     deep:true,
        //     handler(){
        //         if(this.$store.state.handleNodeOption === 'add'){
        //             this.$nextTick(()=>{
        //                             this.$refs.markerTree.setCurrentKey(this.$store.state.addId)
        //                             this.$store.state.selectNode = this.$refs.markerTree.getNode(this.$store.state.addId)
        //                         })
        //             // if(this.selectNode !=='' && this.selectNode.data.type ==='folder'){
        //             //     let len = this.$store.state.selectNode.data.children.length
        //             //     if(len !==0 ){
        //             //         let id = this.$store.state.selectNode.data.children[len-1].id
        //             //         this.$nextTick(()=>{
        //             //             this.$refs.markerTree.setCurrentKey(id)
        //             //             this.$store.state.selectNode = this.$refs.markerTree.getNode(id)
        //             //         })
        //             //     }
        //             // }else{
        //             //     if(this.globeOperationMarkerList.length !== 0 && this.$store.state.globeOperationMarkerList.length >this.oldLength){
        //             //         let id = this.$store.state.globeOperationMarkerList[this.$store.state.globeOperationMarkerList.length-1].id
        //             //         let type = this.$store.state.globeOperationMarkerList[this.$store.state.globeOperationMarkerList.length-1].type
        //             //         this.$nextTick(()=>{
        //             //             if(type != 'folder'){
        //             //                 this.$refs.markerTree.setCurrentKey(id)
        //             //                 this.$store.state.selectNode = this.$refs.markerTree.getNode(id)
        //             //             }
        //             //         })
        //             //     }
        //             //     this.oldLength = this.$store.state.globeOperationMarkerList.length
        //             // }
        //
        //         }
        //     }
        // }
    },
    methods:{
        //创作标记引导视频
        openMarkerGuideVideo(){
            this.$emit("openMarkerGuideVideo","")
        },
        nodeExAndIm(node,data,event){
            event.stopPropagation()
            this.getLabelLockStatus(node,data,this.nodeExAndIm1)
        },
        nodeExAndIm1(node,data){
            if(this.$store.state.currFolderRole === 1 || (this.$store.state.currFolderRole !== 1 && this.$store.state.userId === node.data.userId)) {
                let data1 = new FormData()
                data1.append('fileId', this.$store.state.currFolderId)
                data1.append('labelId', node.data.id)
                if (data.visible)
                    data1.append('visible', false)
                else
                    data1.append('visible', true)
                this.$axios.post('/authorApi/z-geo-file/editLabelVisible',data1)
                    .then((res)=>{
                        if(res.data.status === 200){
                            //离开页面属性
                            if (data.type === 'folder') {
                                if (data.visible) {
                                    data.visible = false
                                    this.markerHandleList = []
                                    this.hideChildren(node, false)
                                } else {
                                    this.markerHandleList = []
                                    data.visible = true
                                    this.hideChildren(node, true)
                                }
                            } else {
                                data.visible = !data.visible
                                this.$store.state.hideControlNode = node
                            }
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = res.data.message
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            }else{
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "暂无权限，请联系创建者"
                this.$store.state.snackbarType = 'error'
            }
        },
        nodeMouseover(node,data){
            data.iconShow = true
          //  this.$store.state.handleNodeOption = 'nodeMouseover'
           //this.$emit("nodeMouseover",data)
        },
        nodeMouseout(node,data){
            data.iconShow = false
         //   this.$store.state.handleNodeOption = 'nodeMouseout'
          // this.$emit("nodeMouseout",data)
        },
        remove(node, data,event) {
          event.stopPropagation()
            this.getLabelLockStatus(node,data,this.remove1)
        },
        remove1(node,data){
            if(this.$store.state.currFolderRole === 1 || (this.$store.state.currFolderRole !== 1 && this.$store.state.userId === node.data.userId)){
                let formData = new FormData()
                formData.append('fileId',this.$store.state.currFolderId)
                formData.append('deleteLabelId',node.data.id)
                this.$axios.post('/authorApi/z-geo-file/deleteLabel',formData)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.deleteNode = node
                            this.markerHandleList = []
                            //离开页面属性

                            if(node.isCurrent){
                                this.cancelSelect()
                            }else{
                                this.removeNodeIsCurrent(node)
                            }
                            const parent = node.parent;
                            const children = parent.data.children || parent.data;
                            const index = children.findIndex(d => d.id === data.id);
                            children.splice(index, 1);
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = res.data.message
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            }else{
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "暂无权限，请联系创建者"
                this.$store.state.snackbarType = 'error'
            }
        },
        allowDrop(draggingNode, dropNode, type){
            if (dropNode.data.type=== 'folder') {
                return true;
            } else {
                return type !== 'inner';
            }
        },
        itemTypeToIcon(val){
            const map={
                "point":'&#xe677;',
                "lineString":'&#xe675;',
                "roadString":'&#xe679;',
                "circle":'&#xe67b;',
                "rectangle":'&#xe67a;',
                "polygon":'&#xe678;',
                "administrativeArea":'&#xe67c;',
                "folder":'&#xe64d;',
            }
            return map[val]
        },
        folderDblclick(node,data){
            if(data.type ==='folder'){
                if(this.$store.state.currFolderRole === 1 || (this.$store.state.currFolderRole !== 1 && this.$store.state.userId === node.data.userId)){
                    data.isEditName= true
                }else{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "暂无权限，请联系创建者"
                    this.$store.state.snackbarType = 'error'
                }
            }
        },
        blurNodeName(data){
            if(this.nodeName.length > 0){
                let data1 = new FormData()
                data1.append('fileId', this.$store.state.currFolderId)
                data1.append('folderId', data.id)
                data1.append('folderName', this.nodeName)
                this.$axios.post('/authorApi/z-geo-file/renameFolder',data1)
                    .then((res)=>{
                        if(res.data.status === 200){
                            data.name =JSON.parse(JSON.stringify(this.nodeName))
                            this.nodeName =''
                            data.isEditName = false
                            //离开页面弹窗
                        }else{
                            this.nodeName =''
                            data.isEditName = false
                        }
                    })
            }else{
                this.nodeName =''
                data.isEditName = false
            }
        },
        handleNodeClick(data,node){
            if(this.$store.state.handleNodeOption === 'modify'){
                //通知修改弹窗
                this.$emit("openNotSavedDialog",)
                //恢复原选中
                this.addMarkerToSelect(this.$store.state.selectNode.data.id)
            }else{
                this.$store.state.handleNodeOption = 'selectNode'
                this.currentNodeKey = data.id;
                this.$store.state.selectNode = node
            }

            //this.$emit("nodeClick",node)
        },
        createFolderElement(){
            this.getGeneratorId(this.createFolderWithId)
        },
        createFolderWithId(id){
          let parentNodeId
          if(this.$store.state.selectNode === ''){
             parentNodeId = ''
          }else{
            if(this.$store.state.selectNode.data.type !=='folder'){
              parentNodeId = ''
            }else{
              parentNodeId= this.$store.state.selectNode.data.id
            }
          }
          let temp =  {
            id:id,
            name:'文件夹',
            type:"folder",
            visible:true,
            iconShow:false,
            isEditName:false,
            geoJson:{
              points:[],
              geo:{},
            },
            children:[]
          }
          this.$axios({
            method:"post",
            url:"/authorApi/z-geo-file/addLabel",
            data:{
              fileId:this.$store.state.currFolderId,
              parentNodeId:parentNodeId,
              labelNode:temp,
            }
          }).then((res)=>{
            if(res.data.status === 200){
              //离开页面属性
              if(this.$store.state.selectNode === ''){
                this.$store.state.globeOperationMarkerList.push(res.data.data)
              }else{
                if(this.$store.state.selectNode.data.type !=='folder'){
                  this.$store.state.globeOperationMarkerList.push(res.data.data)
                }else{
                  this.$store.state.selectNode.data.children.push(res.data.data)
                }
              }
            }else{
              //创建失败了
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = res.data.message
              this.$store.state.snackbarType = 'error'
            }
          }).catch(()=>{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "创建失败"
              this.$store.state.snackbarType = 'error'
          })
        },
        async getGeneratorId(method){
            this.$axios.get('/authorApi/z-geo-file/getGeneratorId').then((res)=>{
                if(res.data.status === 200){
                    method(res.data.data)
                }else{
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = "文件创建失败，请稍后再试"
                  this.$store.state.snackbarType = 'error'
                }
            })
        },
        hideChildren(node,val){
            let len = node.childNodes.length;
            if(len >0){
                for(let i=0;i< len;i++){
                    node.childNodes[i].data.visible = val
                    if(node.childNodes[i].data.type !=='folder'){
                        this.markerHandleList.push(node.childNodes[i].data)
                    }
                    this.hideChildren(node.childNodes[i],val)
                }
            }
            this.$store.state.hideControlNode = node
        },
        removeNodeIsCurrent(node){
            let len = node.childNodes.length;
            if (len > 0){
                for(let i=0;i< len;i++){
                    if(node.childNodes[i].isCurrent){
                        this.cancelSelect()
                    }
                    this.removeNodeIsCurrent(node.childNodes[i])
                }
            }
        },
        //取消选中
        cancelSelect(){
            this.$store.state.selectNode = ''
            this.$nextTick(() => {
                this.$refs.markerTree.setCurrentKey(null);
                this.currentNodeKey = ''
                //this.$refs.markerTree.setCheckedNodes([])
            });
        },
        handleDragEnd(draggingNode,dropNode,ev){
          if(this.$store.state.currFolderRole === 1){
            let data = new FormData()
            data.append('fileId',this.$store.state.currFolderId)
            data.append('fromLabelId',draggingNode.data.id)
            data.append('toLabelId',dropNode.data.id)
            data.append('action',ev)
            this.$axios.post('/authorApi/z-geo-file/moveLabel',data)
          }

            //this.$emit('initMapMarker',this.$store.state.globeOperationMarkerList)
            // if(draggingNode.data.id !== dropNode.data.id){
            //     if(draggingNode.data.type === 'point'){
            //         draggingNode.data.geoJson.geo.properties.size = this.currSize
            //     }else{
            //         draggingNode.data.geoJson.geo.properties.width = this.currWidth
            //     }
            // }

        },
      /*  handleDragStart(node, ev) {
            //开始拖拽保存属性
            // if(node.data.type == 'point'){
            //     this.currSize = node.data.geoJson.geo.properties.size - 0.2
            // }else{
            //     this.currWidth = node.data.geoJson.geo.properties.width - 2
            // }

            //console.log("当前尺寸："+this.currSize)

        },
        handleDragEnter(draggingNode, dropNode, ev) {
            console.log('tree drag enter: ', draggingNode);
            console.log('tree drag enter: ', dropNode);
            console.log(ev)
        },
        handleDragLeave(draggingNode, dropNode, ev) {
            console.log('tree drag leave: ', draggingNode);
            console.log('tree drag leave: ', dropNode);
            console.log(ev)
        },
        handleDragOver(draggingNode, dropNode) {
            console.log('tree drag over: ', dropNode.label);
            // console.log(ev)
        },*/

        addMarkerToSelect(id){
            this.$nextTick(()=>{
                this.$refs.markerTree.setCurrentKey(id)
                this.$store.state.selectNode = this.$refs.markerTree.getNode(id)
            })
        },

        getLabelLockStatus(node,data,method){
            this.$axios.get('/authorApi/z-geo-file/getLabelLockStatus',{
                params:{
                    fileId:this.$store.state.currFolderId,
                    labelId:data.id
                }
            }).then((res)=>{
                if(res.data.status === 200){
                    this.$store.state.selectNode.data.avatar = res.data.data.avatar
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "该数据已被锁定"
                    this.$store.state.snackbarType = 'error'
                }else{
                    method(node,data)
                }
            })
            //     .catch(()=>{
            //     method()
            // })
        },


        //''''''''''''''''''''''''''''''图层列表''''''''''''''''''''''''''''''''''''''''''''''''
        removeLayerNode(node,data,event){
            event.stopPropagation()
            if(this.$store.state.currFolderRole === 1 || (this.$store.state.currFolderRole !== 1 && this.$store.state.userId === node.data.userId)){
                let formData = new FormData()
                formData.append('fileId',this.$store.state.currFolderId)
                formData.append('layerId',data.layerId)
                this.$axios.post('/authorApi/z-geo-file/deleteLayer',formData)
                    .then((res)=>{
                        if(res.data.status === 200){
                            if(node.isCurrent){
                                this.cancelLayerTreeSelect()
                                //清除图层显示
                            }

                            const parent = node.parent;
                            const children = parent.data.children || parent.data;
                            const index = children.findIndex(d => d.layerId === data.layerId);
                            children.splice(index, 1);
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = res.data.message
                            this.$store.state.snackbarType = 'error'
                        }
                    }).catch(()=>{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "删除失败"
                    this.$store.state.snackbarType = 'error'
                })
            }else{
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "暂无权限，请联系创建者"
                this.$store.state.snackbarType = 'error'
            }
        },

        //取消选中
        cancelLayerTreeSelect(){
            if(this.currentLayerNodeKey != null){
                this.$nextTick(() => {
                    this.$refs.layerTree.setCurrentKey(null);
                    this.currentLayerNodeKey=''
                    //this.$refs.markerTree.setCheckedNodes([])
                });
            }
            this.$store.state.selectLayerTreeNode = ''
        },
        layerNodeMouseover(node,data){
            data.iconShow = true
        },
        layerNodeMouseout(node,data){
            data.iconShow = false
        },
        //
        layerTreeNodeClick(data,node){
          // this.smallGlobeMapInit &&
            if(this.mapboxInit){
                if(this.$store.state.selectLayerTreeNode === ''){
                    this.currentLayerNodeKey = data.layerId;
                    this.$store.state.selectLayerTreeNode = node
                }else{
                    if(this.$store.state.selectLayerTreeNode.data.layerId ===data.layerId){
                        this.$store.state.selectLayerTreeNode = ''
                        setTimeout(()=> this.cancelLayerTreeSelect(),10)
                    }else{
                        this.currentLayerNodeKey = data.layerId;
                        this.$store.state.selectLayerTreeNode = node
                    }
                }
            }else{
                this.$store.state.selectLayerTreeNode = ''
                setTimeout(()=> this.cancelLayerTreeSelect(),10)
                this.$store.state.snackbarShow = true
                this.$store.state.snackbarText ='地球资源加载中，请稍后再试'
                this.$store.state.snackbarType = 'error'
            }


        },

        //面板操作
        dataPanelOperation(val){
            if(val === 'open'){
                //关闭所有的图层操作
               //选中的node取消
                //显示数据列表的图层
                this.$emit("isShowDataListEffect","true")
                //清除图层列表的图层
                this.dataListShow = true
                this.layerListShow = false
                this.cancelSelect()
            }else{
                //判断是不是在修改
                if(this.$store.state.handleNodeOption === 'modify')
                    this.$emit("openNotSavedDialog",)
                else{
                    //清除效果
                    this.$emit("isShowDataListEffect","false")
                    this.dataListShow = false
                    this.layerListShow = true
                    this.cancelLayerTreeSelect()
                }
            }
        },
        layerPanelOperation(val){
            if(val === 'open'){
                //判断是不是在修改
                if(this.$store.state.handleNodeOption === 'modify')
                    this.$emit("openNotSavedDialog",)
                else{
                    //清除效果
                    this.$emit("isShowDataListEffect","false")
                    this.dataListShow = false
                    this.layerListShow = true
                    this.cancelLayerTreeSelect()
                }
            }else{//选中的node取消
                this.cancelSelect()
                //显示数据列表的图层
                this.$emit("isShowDataListEffect","true")
                //清除图层列表的图层
                this.dataListShow = true
                this.layerListShow = false
            }
        },
        getFileIsUpdate(){
            this.$axios.get('/authorApi/z-geo-file-operation/isFileUpdate',{
                params:{
                    fileId:this.$store.state.currFolderId
                }
            }).then((res)=>{
                if(res.data.status === 200){
                    this.isNewData = true
                }else{
                    this.isNewData = false
                }
            }).catch(()=>{
                this.isNewData = false
            })
        },

        refreshData(){
            //清除红点
            this.isNewData = false
            this.openFolderById(this.$store.state.currFolderId)
        },

        getNewNoRead(){
            this.$axios.get('/authorApi/z-geo-file-operation/getOneNotRead',{
                params:{
                    fileId:this.$store.state.currFolderId
                }
            }).then((res)=>{
                if(res.data.status === 200){
                    this.$emit("pushNoReadData",res.data.data)
                }
            })
        },

        successToLayer(id){
            if(!this.layerListShow){
                this.$emit("isShowDataListEffect","false")
                this.dataListShow = false
                this.layerListShow = true
            }
            this.$store.state.selectLayerTreeNode=''
            this.$nextTick(()=>{
                this.$refs.layerTree.setCurrentKey(id)
                this.$store.state.selectLayerTreeNode = this.$refs.layerTree.getNode(id)
            })
        },
        successToData(){
            if(!this.dataListShow){
                //显示数据列表的图层
                this.$emit("isShowDataListEffect","true")
                //清除图层列表的图层
                this.dataListShow = true
                this.layerListShow = false
            }
        },
        //切换回来显示数据列表
        initFolderLayer(){
            this.dataListShow = true
            this.layerListShow = false
        }
    },

    computed:{
        // globeOperationMarkerList(){
        //     return  this.$store.state.globeOperationMarkerList
        // },
        selectNode(){
            return this.$store.state.selectNode
        }
    }
}
</script>

<style scoped>

</style>
